<template>
    <div class="prize-display-container">
<!--         <img class="flowers" src="/static/img/flowers.png" /> -->

        <img src="/static/img/prize-display.png" />

        <div class="ball-container">
            <div class="padding-bottom-wrapper">
                <transition-group appear v-on:enter="onEnter">
                    <v-ball v-for="(n, index) in balls" :key="index" :number="n" :size="innerHeight * 0.0694" :style="{ 'left': 'calc( ( 100% * 0.1671 * ' + index + ' )' }"></v-ball>
                </transition-group>
            </div>
        </div>
        <img class="hoofdprijs" src="/static/img/hoofdprijs-label.png" />
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    import { TimelineMax, TweenMax } from '@/vendor';
    import Ball from '@/app/components/Ball';

    export default {
        components: {
            'v-ball': Ball
        },

        computed: {
            balls()
            {
                return this.$store.getters['getCorrectBalls'];
            }
        },

        data()
        {
            return {
                innerHeight: window.innerHeight
            };
        },

        mounted()
        {

        },

        methods: {
            onEnter( el, done )
            {
                let tl = new TimelineMax({
                    delay: 0.8,
                    onComplete: () =>
                    {
                        done();
                    }
                });

                TweenMax.set( el.querySelector( 'svg > g' ), { transformOrigin: '87.5px 87.5px 0px', rotation: 0.001 });

                let sX = 0.65;
                let sY = 0.9;
                let xDist = 175;

                let time = 0.4;
                let waitFor = 1 - time;

                let singleSpinTween = new TimelineMax({ repeat: -1 });
                singleSpinTween.fromTo( el.querySelector( 'svg > g' ), 1, { x: xDist }, { x: -xDist, ease: Linear.easeNone }, 0 );
                singleSpinTween.fromTo( el.querySelector( 'svg > g' ), time, { scaleY: sY, scaleX: sX }, { scaleY: 1, scaleX: 1, ease: Linear.easeNone }, 0.1 );
                singleSpinTween.fromTo( el.querySelector( 'svg > g' ), time, { scaleY: 1, scaleX: 1 }, { scaleY: sY, scaleX: sX, ease: Linear.easeNone }, waitFor - 0.1 );

                let multiSpinTween = new TimelineMax({ paused: true });
                multiSpinTween.add( singleSpinTween );

                tl.from( el, 0.3, { opacity: 0, scale: 0 }, 0 );
                tl.to( multiSpinTween, 2, { time: 15.5, ease: Circ.easeOut }, 0 );
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/components/PrizeDisplay.vue